import React from 'react';
import { Box, Typography } from '@mui/material';

// Shared section chrome for the proof/apply-to selectors: a lightly
// bordered box with an uppercase eyebrow title and one instruction line.
export default function SelectorSection({ title, instruction, children, sx }) {
  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        p: 2,
        ...sx,
      }}
    >
      <Box sx={{ mb: 1 }}>
        <Typography
          component="div"
          sx={{
            fontSize: '0.6875rem',
            fontWeight: 600,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: 'text.secondary',
          }}
        >
          {title}
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          {instruction}
        </Typography>
      </Box>
      {children}
    </Box>
  );
}
